import { Link } from "react-router-dom";
import * as React from "react";
import { developAxios } from "../axios.config";
import { Alert } from "react-bootstrap";

const DeleteSubProject = () => {
	const [projects, setProjects] = React.useState([]);
	const [project, setProject] = React.useState("");

	const [subProject, setSubProject] = React.useState("");
	const [subProjects, setSubProjects] = React.useState([]);

	const [course, setCourse] = React.useState("");
	const [courses, setCourses] = React.useState([]);

	// select course
	React.useEffect(() => {
		const controller = new AbortController();

		developAxios(localStorage.getItem("token"))
			.get("/getallcourse", {
				signal: controller.signal,
			})
			.then(({ data }) => {
				console.log(data);
				setCourses(data.courses);
			})
			.catch((err) => console.log(err?.response));

		return () => controller.abort();
	}, []);

	// select course

	React.useEffect(() => {
		if (course === "") return;
		const controller = new AbortController();

		developAxios(localStorage.getItem("token"))
			.get("/dashboard/get-projects-by-courseId/" + course, {
				signal: controller.signal,
			})
			.then(({ data }) => {
				console.log(data);
				setProjects(data.projects);
			})
			.catch((err) => console.log(err?.response));

		return () => controller.abort();
	}, [course]);

	React.useEffect(() => {
		if (project === "") return;
		const controller = new AbortController();

		developAxios(localStorage.getItem("token"))
			.get("/dashboard/get-sub-projects-by-parentId/" + project, {
				signal: controller.signal,
			})
			.then(({ data }) => {
				console.log(data);
				setSubProjects(data.projects);
			})
			.catch((err) => console.log(err?.response));

		return () => controller.abort();
	}, [project]);

	const handleSubmit = (e) => {
		e.preventDefault();
		developAxios(localStorage.getItem("token"))
			.delete("/dashboard/delete-sub-project/" + subProject)
			.then(({ data }) => {
				console.log(data);
				alert("Project Deleted Successfully");
				window.location.reload();
			})
			.catch((err) => console.log(err?.response));
	};

	return (
		<div
			style={{
				display: "flex",
				justifyContent: "center",
				alignItems: "flex-start",
				flexDirection: "column",
			}}
		>
			<div
				style={{
					alignSelf: "center",
					width: "500px",
					paddingBottom: "50px",
					paddingTop: "50px",
				}}
			>
				<div
					style={{
						display: "flex",
						flexDirection: "column",
					}}
				>
					<h5>Course:</h5>{" "}
					<select
						// className="w-50"
						aria-label="Default select example"
						name="course_select"
						id="course_select"
						onChange={(e) => {
							// set id of course
							setCourse(e.target.value);
						}}
					>
						<option value="">Select Course</option>
						{courses.map((val) => {
							return (
								<option value={val._id} key={val.id}>
									{val?.name}
								</option>
							);
						})}
					</select>
				</div>
				<div
					style={{
						display: "flex",
						flexDirection: "column",
						marginTop: "30px",
					}}
				>
					<h5>Projects:</h5>{" "}
					<select
						// className="w-50"
						aria-label="Default select example"
						name="course_select"
						id="course_select"
						onChange={(e) => {
							// set id of course
							setProject(e.target.value);
						}}
					>
						<option value="">Select Projects</option>
						{projects.map((val) => {
							return (
								<option value={val._id} key={val.id}>
									{val?.projectName}
								</option>
							);
						})}
					</select>
				</div>

				<div
					style={{
						display: "flex",
						flexDirection: "column",
					}}
				>
					<h5>Sub Projects:</h5>{" "}
					<select
						// className="w-50"
						aria-label="Default select example"
						name="sub_project_select"
						id="sub_project_select"
						onChange={(e) => {
							// set id of course
							setSubProject(e.target.value);
						}}
					>
						<option value="">Select Sub Projects</option>
						{subProjects.map((val) => {
							return (
								<option value={val._id} key={val.id}>
									{val?.projectName}
								</option>
							);
						})}
					</select>
				</div>
				{/* delete button */}
				<button
					className="btn btn-primary"
					style={{
						width: "100%",
						marginTop: "30px",
						marginBottom: "20px",
					}}
					onClick={handleSubmit}
				>
					Delete Project
				</button>
			</div>
		</div>
	);
};

export default DeleteSubProject;
